import { Link } from "react-router-dom";
import { categories } from "@/mocks/games";

const socialLinks = [
  { icon: "ri-weibo-fill", label: "微博", href: "https://weibo.com" },
  { icon: "ri-wechat-fill", label: "微信", href: "#" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩", href: "https://www.bilibili.com" },
  { icon: "ri-youtube-fill", label: "视频号", href: "https://www.youtube.com" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-screen2xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-gamepad-line text-xl"></i>
              </span>
              <span className="text-lg font-black text-background-50">网页游戏直接玩</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              海量热门网页游戏在线试玩，覆盖竞技、角色扮演、休闲等多种类型。免下载安装，打开网页即刻开玩。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-100 transition hover:bg-primary-500"
                >
                  <i className={`${item.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <a href="#footer-nav">网站导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <Link to="/" className="transition hover:text-primary-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition hover:text-primary-300">
                  全站搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-300">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <a href="#footer-category">游戏分类</a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm text-background-200">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link to={`/category/${category.key}`} className="transition hover:text-primary-300">
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">
              <a href="#footer-help">友情链接与帮助</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <a href="https://developers.weixin.qq.com" target="_blank" rel="noreferrer noopener" className="transition hover:text-primary-300">
                  开发者社区
                </a>
              </li>
              <li>
                <a href="https://www.gameres.com" target="_blank" rel="noreferrer noopener" className="transition hover:text-primary-300">
                  游戏行业资讯
                </a>
              </li>
              <li>
                <span className="flex items-center gap-1.5">
                  <i className="ri-mail-line text-primary-400"></i>
                  support@webgameplay.example
                </span>
              </li>
              <li>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-primary-400"></i>
                  客服时间：每日 9:00 - 21:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-900 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© 2026 网页游戏直接玩 · 本站游戏信息为虚拟演示数据，仅供展示使用</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-400"></i>
            免下载 · 免安装 · 打开即玩
          </p>
        </div>
      </div>
    </footer>
  );
}